export default __webpack_public_path__ + "static/media/contactExit.e9c47868.svg";